/**
 * A bottom sheet's heights (the quick look on a phone): half the screen, or nearly all of it; dragged by its handle,
 * it settles on the nearest, a flick goes the way it's flicked (down: closed), and dragged low enough it closes.
 */

/** As fast as this (px per ms) is a flick. */
const FLICK = 0.5;
/** Below this share of the screen, let go, it closes. */
const CLOSE_BELOW = 0.25;

export type Snap = "half" | "full";

/** Each height, as a share of the screen's. */
export const SNAPS: Record<Snap, number> = { half: 0.5, full: 0.92 };

/** The height a sheet dragged to `height` (px, on a screen `screen` tall) can take while dragged: up to its tallest. */
export const dragged = (height: number, screen: number): number => Math.max(0, Math.min(height, SNAPS.full * screen));

/**
 * Where a sheet let go at `height` (px) on a screen `screen` tall settles, moving at `velocity` (px per ms, down
 * positive): flicked down, closed; flicked up, full; else closed if low enough, or the nearest height.
 */
export function settle(height: number, screen: number, velocity: number): Snap | "closed" {
  if (velocity > FLICK) {
    return "closed";
  }
  if (velocity < -FLICK) {
    return "full";
  }
  const share = height / screen;
  if (share < CLOSE_BELOW) {
    return "closed";
  }
  return Math.abs(share - SNAPS.half) <= Math.abs(share - SNAPS.full) ? "half" : "full";
}
